/*! For license information please see component.js.LICENSE.txt */
!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e(require("lodash.throttle")) : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports.AblyUi = e(require("lodash.throttle")) : (t.AblyUi = t.AblyUi || {}, t.AblyUi.Core = t.AblyUi.Core || {}, t.AblyUi.Core.CompanyAutocomplete = e(t[void 0]));
}(this, t => (() => {
  var e = {
      7326: e => {
        "use strict";

        e.exports = t;
      },
      7061: (t, e, r) => {
        var n = r(8698).default;
        function o() {
          "use strict";

          t.exports = o = function () {
            return r;
          }, t.exports.__esModule = !0, t.exports.default = t.exports;
          var e,
            r = {},
            a = Object.prototype,
            i = a.hasOwnProperty,
            c = Object.defineProperty || function (t, e, r) {
              t[e] = r.value;
            },
            u = "function" == typeof Symbol ? Symbol : {},
            s = u.iterator || "@@iterator",
            l = u.asyncIterator || "@@asyncIterator",
            f = u.toStringTag || "@@toStringTag";
          function p(t, e, r) {
            return Object.defineProperty(t, e, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }), t[e];
          }
          try {
            p({}, "");
          } catch (e) {
            p = function (t, e, r) {
              return t[e] = r;
            };
          }
          function d(t, e, r, n) {
            var o = e && e.prototype instanceof x ? e : x,
              a = Object.create(o.prototype),
              i = new G(n || []);
            return c(a, "_invoke", {
              value: A(t, r, i)
            }), a;
          }
          function h(t, e, r) {
            try {
              return {
                type: "normal",
                arg: t.call(e, r)
              };
            } catch (t) {
              return {
                type: "throw",
                arg: t
              };
            }
          }
          r.wrap = d;
          var y = "suspendedStart",
            v = "suspendedYield",
            m = "executing",
            g = "completed",
            b = {};
          function x() {}
          function w() {}
          function E() {}
          var L = {};
          p(L, s, function () {
            return this;
          });
          var _ = Object.getPrototypeOf,
            j = _ && _(_(q([])));
          j && j !== a && i.call(j, s) && (L = j);
          var O = E.prototype = x.prototype = Object.create(L);
          function S(t) {
            ["next", "throw", "return"].forEach(function (e) {
              p(t, e, function (t) {
                return this._invoke(e, t);
              });
            });
          }
          function k(t, e) {
            function r(o, a, c, u) {
              var s = h(t[o], t, a);
              if ("throw" !== s.type) {
                var l = s.arg,
                  f = l.value;
                return f && "object" == n(f) && i.call(f, "__await") ? e.resolve(f.__await).then(function (t) {
                  r("next", t, c, u);
                }, function (t) {
                  r("throw", t, c, u);
                }) : e.resolve(f).then(function (t) {
                  l.value = t, c(l);
                }, function (t) {
                  return r("throw", t, c, u);
                });
              }
              u(s.arg);
            }
            var o;
            c(this, "_invoke", {
              value: function (t, n) {
                function a() {
                  return new e(function (e, o) {
                    r(t, n, e, o);
                  });
                }
                return o = o ? o.then(a, a) : a();
              }
            });
          }
          function A(t, r, n) {
            var o = y;
            return function (a, i) {
              if (o === m) throw new Error("Generator is already running");
              if (o === g) {
                if ("throw" === a) throw i;
                return {
                  value: e,
                  done: !0
                };
              }
              for (n.method = a, n.arg = i;;) {
                var c = n.delegate;
                if (c) {
                  var u = N(c, n);
                  if (u) {
                    if (u === b) continue;
                    return u;
                  }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
                  if (o === y) throw o = g, n.arg;
                  n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = m;
                var s = h(t, r, n);
                if ("normal" === s.type) {
                  if (o = n.done ? g : v, s.arg === b) continue;
                  return {
                    value: s.arg,
                    done: n.done
                  };
                }
                "throw" === s.type && (o = g, n.method = "throw", n.arg = s.arg);
              }
            };
          }
          function N(t, r) {
            var n = r.method,
              o = t.iterator[n];
            if (o === e) return r.delegate = null, "throw" === n && t.iterator.return && (r.method = "return", r.arg = e, N(t, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), b;
            var a = h(o, t.iterator, r.arg);
            if ("throw" === a.type) return r.method = "throw", r.arg = a.arg, r.delegate = null, b;
            var i = a.arg;
            return i ? i.done ? (r[t.resultName] = i.value, r.next = t.nextLoc, "return" !== r.method && (r.method = "next", r.arg = e), r.delegate = null, b) : i : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, b);
          }
          function P(t) {
            var e = {
              tryLoc: t[0]
            };
            1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
          }
          function T(t) {
            var e = t.completion || {};
            e.type = "normal", delete e.arg, t.completion = e;
          }
          function G(t) {
            this.tryEntries = [{
              tryLoc: "root"
            }], t.forEach(P, this), this.reset(!0);
          }
          function q(t) {
            if (t || "" === t) {
              var r = t[s];
              if (r) return r.call(t);
              if ("function" == typeof t.next) return t;
              if (!isNaN(t.length)) {
                var o = -1,
                  a = function r() {
                    for (; ++o < t.length;) if (i.call(t, o)) return r.value = t[o], r.done = !1, r;
                    return r.value = e, r.done = !0, r;
                  };
                return a.next = a;
              }
            }
            throw new TypeError(n(t) + " is not iterable");
          }
          return w.prototype = E, c(O, "constructor", {
            value: E,
            configurable: !0
          }), c(E, "constructor", {
            value: w,
            configurable: !0
          }), w.displayName = p(E, f, "GeneratorFunction"), r.isGeneratorFunction = function (t) {
            var e = "function" == typeof t && t.constructor;
            return !!e && (e === w || "GeneratorFunction" === (e.displayName || e.name));
          }, r.mark = function (t) {
            return Object.setPrototypeOf ? Object.setPrototypeOf(t, E) : (t.__proto__ = E, p(t, f, "GeneratorFunction")), t.prototype = Object.create(O), t;
          }, r.awrap = function (t) {
            return {
              __await: t
            };
          }, S(k.prototype), p(k.prototype, l, function () {
            return this;
          }), r.AsyncIterator = k, r.async = function (t, e, n, o, a) {
            void 0 === a && (a = Promise);
            var i = new k(d(t, e, n, o), a);
            return r.isGeneratorFunction(e) ? i : i.next().then(function (t) {
              return t.done ? t.value : i.next();
            });
          }, S(O), p(O, f, "Generator"), p(O, s, function () {
            return this;
          }), p(O, "toString", function () {
            return "[object Generator]";
          }), r.keys = function (t) {
            var e = Object(t),
              r = [];
            for (var n in e) r.push(n);
            return r.reverse(), function t() {
              for (; r.length;) {
                var n = r.pop();
                if (n in e) return t.value = n, t.done = !1, t;
              }
              return t.done = !0, t;
            };
          }, r.values = q, G.prototype = {
            constructor: G,
            reset: function (t) {
              if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(T), !t) for (var r in this) "t" === r.charAt(0) && i.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = e);
            },
            stop: function () {
              this.done = !0;
              var t = this.tryEntries[0].completion;
              if ("throw" === t.type) throw t.arg;
              return this.rval;
            },
            dispatchException: function (t) {
              if (this.done) throw t;
              var r = this;
              function n(n, o) {
                return c.type = "throw", c.arg = t, r.next = n, o && (r.method = "next", r.arg = e), !!o;
              }
              for (var o = this.tryEntries.length - 1; o >= 0; --o) {
                var a = this.tryEntries[o],
                  c = a.completion;
                if ("root" === a.tryLoc) return n("end");
                if (a.tryLoc <= this.prev) {
                  var u = i.call(a, "catchLoc"),
                    s = i.call(a, "finallyLoc");
                  if (u && s) {
                    if (this.prev < a.catchLoc) return n(a.catchLoc, !0);
                    if (this.prev < a.finallyLoc) return n(a.finallyLoc);
                  } else if (u) {
                    if (this.prev < a.catchLoc) return n(a.catchLoc, !0);
                  } else {
                    if (!s) throw new Error("try statement without catch or finally");
                    if (this.prev < a.finallyLoc) return n(a.finallyLoc);
                  }
                }
              }
            },
            abrupt: function (t, e) {
              for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                var n = this.tryEntries[r];
                if (n.tryLoc <= this.prev && i.call(n, "finallyLoc") && this.prev < n.finallyLoc) {
                  var o = n;
                  break;
                }
              }
              o && ("break" === t || "continue" === t) && o.tryLoc <= e && e <= o.finallyLoc && (o = null);
              var a = o ? o.completion : {};
              return a.type = t, a.arg = e, o ? (this.method = "next", this.next = o.finallyLoc, b) : this.complete(a);
            },
            complete: function (t, e) {
              if ("throw" === t.type) throw t.arg;
              return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), b;
            },
            finish: function (t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), T(r), b;
              }
            },
            catch: function (t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                  var n = r.completion;
                  if ("throw" === n.type) {
                    var o = n.arg;
                    T(r);
                  }
                  return o;
                }
              }
              throw new Error("illegal catch attempt");
            },
            delegateYield: function (t, r, n) {
              return this.delegate = {
                iterator: q(t),
                resultName: r,
                nextLoc: n
              }, "next" === this.method && (this.arg = e), b;
            }
          }, r;
        }
        t.exports = o, t.exports.__esModule = !0, t.exports.default = t.exports;
      },
      8698: t => {
        function e(r) {
          return t.exports = e = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
            return typeof t;
          } : function (t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
          }, t.exports.__esModule = !0, t.exports.default = t.exports, e(r);
        }
        t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
      },
      4687: (t, e, r) => {
        var n = r(7061)();
        t.exports = n;
        try {
          regeneratorRuntime = n;
        } catch (t) {
          "object" == typeof globalThis ? globalThis.regeneratorRuntime = n : Function("r", "regeneratorRuntime = r")(n);
        }
      }
    },
    r = {};
  function n(t) {
    var o = r[t];
    if (void 0 !== o) return o.exports;
    var a = r[t] = {
      exports: {}
    };
    return e[t](a, a.exports, n), a.exports;
  }
  n.n = t => {
    var e = t && t.__esModule ? () => t.default : () => t;
    return n.d(e, {
      a: e
    }), e;
  }, n.d = (t, e) => {
    for (var r in e) n.o(e, r) && !n.o(t, r) && Object.defineProperty(t, r, {
      enumerable: !0,
      get: e[r]
    });
  }, n.o = (t, e) => Object.prototype.hasOwnProperty.call(t, e);
  var o = {};
  return (() => {
    "use strict";

    n.d(o, {
      default: () => h
    });
    var t = n(4687),
      e = n.n(t),
      r = n(7326),
      a = n.n(r);
    function i(t, e, r, n, o, a, i) {
      try {
        var c = t[a](i),
          u = c.value;
      } catch (t) {
        return void r(t);
      }
      c.done ? e(u) : Promise.resolve(u).then(n, o);
    }
    function c(t) {
      return function () {
        var e = this,
          r = arguments;
        return new Promise(function (n, o) {
          var a = t.apply(e, r);
          function c(t) {
            i(a, n, o, c, u, "next", t);
          }
          function u(t) {
            i(a, n, o, c, u, "throw", t);
          }
          c(void 0);
        });
      };
    }
    var u = function (t) {
        return t.parentNode.querySelector("[data-id=company-autocomplete-dropdown]");
      },
      s = function (t) {
        return t ? t.querySelectorAll("li > button") : [];
      },
      l = function (t) {
        return Array.from(t).indexOf(document.activeElement);
      },
      f = function (t) {
        var e = u(t);
        e && (e.classList.add("hidden"), e.querySelector("ol").innerHTML = "");
      },
      p = function (t, e) {
        var r = t.parentNode,
          n = function (t) {
            var e = u(t);
            if (!e) {
              t.parentNode.style.position = "relative", (e = document.createElement("div")).dataset.id = "company-autocomplete-dropdown", e.classList.add("ui-company-autocomplete-container");
              var r = document.createElement("ol");
              return r.classList.add("ui-company-autocomplete-list"), {
                container: e,
                list: r
              };
            }
            return {
              container: e,
              list: e.querySelector("ol")
            };
          }(t),
          o = n.container,
          a = n.list,
          i = function (t) {
            return t.map(function (t) {
              var e = document.createElement("li");
              e.classList.add("ui-company-autocomplete-listitem");
              var r = document.createElement("button");
              r.classList.add("ui-company-autocomplete-btn"), r.dataset.name = t.name;
              var n = document.createElement("img");
              n.alt = "".concat(t.name, " logo"), n.src = t.logo, n.classList.add("ui-company-autocomplete-logo");
              var o = document.createElement("p");
              o.textContent = t.name, o.classList.add("ui-company-autocomplete-name");
              var a = document.createElement("p");
              return a.textContent = t.domain, a.classList.add("ui-company-autocomplete-domain"), r.append(n), r.append(o), r.append(a), e.append(r), e;
            });
          }(e);
        f(t), i.forEach(function (r, n) {
          a.append(r), r.addEventListener("click", function (r) {
            t.value = e[n].name, r.preventDefault();
          });
        }), o.append(a), o.classList.remove("hidden"), r.append(o);
      },
      d = function () {
        var t = c(e().mark(function t(r, n) {
          var o, a;
          return e().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                if (t.prev = 0, n) {
                  t.next = 3;
                  break;
                }
                return t.abrupt("return", []);
              case 3:
                return t.next = 5, fetch("".concat(r, "?query=").concat(n));
              case 5:
                return o = t.sent, t.next = 8, o.json();
              case 8:
                return a = t.sent, t.abrupt("return", a);
              case 12:
                return t.prev = 12, t.t0 = t.catch(0), console.error(t.t0), t.abrupt("return", []);
              case 16:
              case "end":
                return t.stop();
            }
          }, t, null, [[0, 12]]);
        }));
        return function (e, r) {
          return t.apply(this, arguments);
        };
      }();
    const h = function (t, r) {
      t && r && (t.setAttribute("autocomplete", "off"), t.addEventListener("keyup", a()(function () {
        var n = c(e().mark(function n(o) {
          var a, i;
          return e().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                if (!["Enter", "Space", "Tab", "Escape"].includes(o.code)) {
                  e.next = 2;
                  break;
                }
                return e.abrupt("return");
              case 2:
                return a = o.target.value, e.next = 5, d(r, a);
              case 5:
                (i = e.sent) && i.length > 0 && p(t, i);
              case 7:
              case "end":
                return e.stop();
            }
          }, n);
        }));
        return function (t) {
          return n.apply(this, arguments);
        };
      }(), 100, {
        trailing: !0
      })), t.parentNode.addEventListener("keydown", function (e) {
        "ArrowDown" === e.code ? function (t, e) {
          var r = u(t),
            n = s(r),
            o = l(n);
          0 !== n.length && (document.activeElement === t ? n[0].focus() : o >= 0 && o < n.length - 1 && n[o + 1].focus(), e.preventDefault());
        }(t, e) : "ArrowUp" === e.code ? function (t, e) {
          var r = u(t),
            n = s(r),
            o = l(n);
          0 !== n.length && (0 === o ? t.focus() : o > 0 && n[o - 1].focus(), e.preventDefault());
        }(t, e) : "Enter" === e.code || "Space" === e.code ? function (t, e) {
          e.target.dataset.name && (t.value = e.target.dataset.name, f(t), t.focus(), e.preventDefault());
        }(t, e) : "Tab" === e.code ? function (t, e) {
          var r = u(t),
            n = s(r),
            o = l(n);
          (document.activeElement === t && e.shiftKey || o === n.length - 1) && f(t);
        }(t, e) : "Escape" === e.code && f(t);
      }), document.body.addEventListener("click", function () {
        f(t);
      }));
    };
  })(), o.default;
})());